import React from 'react'
import { Link } from "react-router-dom";

export const FooterUsefullLinksColm = () => {
  return (
    <div className="uselink">
      <h4>Usefull Links</h4>
      <div className="footerlink">
        <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="#">About Us</Link></li>
            <li><Link to="#">Private Yachts</Link></li>
            <li><Link to="#">Sunset Cruise</Link></li>
            <li><Link to="#">Events</Link></li>
        </ul>
      </div>
    </div>
  )
}
